import type { useCreateStore } from 'leva';
import { createContext, use } from 'react';

type LevaStore = ReturnType<typeof useCreateStore>;

export const ExperimentsLevaStoreContext = createContext<LevaStore | null>(null);

/**
 * @returns The shared leva store owned by the experiments layout, so a scene's controls and the
 *   tier controls register into one always-on panel; throws when used outside the layout
 */
export function useExperimentsLevaStore(): LevaStore {
  const store = use(ExperimentsLevaStoreContext);
  if (null === store) {
    throw new Error('useExperimentsLevaStore must be used within the experiments layout');
  }
  return store;
}
